<template>
  <md-card>
    <md-card-header class="md-layout md-gutter">
      <div class="form-scope md-layout-item md-size-100 md-title">
        <md-icon class="md-primary md-size-1x" style="margin: 0 10px 5px 10px">
          description
        </md-icon>
        Presupuesto
      </div>
      <div
        class="form-scope md-layout-item md-size-100 md-layout md-alignment-center-left"
      >
        <h4 class="md-layout-item md-size-100">Alcance presupuestado</h4>
        <div
          class="md-layout-item md-size-20 md-medium-size-33 md-small-size-50"
        >
          <md-field class="md-item md-size-25">
            <label> Alcance en días</label>
            <md-input
              v-model="quantification.scope"
              type="number"
              min="0"
              :disabled="true"
            ></md-input>
          </md-field>
        </div>

        <div
          class="md-layout-item md-size-20 md-medium-size-33 md-small-size-50"
        >
          <md-field class="md-item md-size-25">
            <label> Maestros necesarios </label>
            <md-input
              v-model="quantification.masters"
              type="number"
              min="0"
              :disabled="true"
            ></md-input>
          </md-field>
        </div>

        <div
          class="md-layout-item md-size-20 md-medium-size-33 md-small-size-50"
        >
          <md-field class="md-item md-size-25">
            <label> Oficiales necesarios </label>
            <md-input
              v-model="quantification.officials"
              type="number"
              min="0"
              :disabled="true"
            ></md-input>
          </md-field>
        </div>

        <div
          class="md-layout-item md-size-20 md-medium-size-33 md-small-size-50"
        >
          <md-field class="md-item md-size-25">
            <label> Ayudantes necesarios </label>
            <md-input
              v-model="quantification.assistants"
              type="number"
              min="0"
              :disabled="true"
            ></md-input>
          </md-field>
        </div>

        <div
          class="md-layout-item md-size-20 md-medium-size-33 md-small-size-50"
        >
          <md-field class="md-item md-size-25">
            <label> Bandereros necesarios </label>
            <md-input
              v-model="quantification.flagWorkers"
              type="number"
              min="0"
              :disabled="true"
            ></md-input>
          </md-field>
        </div>
      </div>
      <div
        class="form-scope md-layout-item md-size-100 md-layout md-alignment-center-left"
      >
        <h4 class="md-layout-item md-size-100">Alcance real</h4>
        <div
          class="md-layout-item md-size-20 md-medium-size-33 md-small-size-50"
        >
          <md-field class="md-item md-size-25">
            <label> Alcance en días</label>
            <md-input
              v-model="quantification.workedDays"
              type="number"
              min="0"
              :disabled="true"
            ></md-input>
          </md-field>
        </div>

        <div
          class="md-layout-item md-size-20 md-medium-size-33 md-small-size-50"
        >
          <md-field class="md-item md-size-25">
            <label> Maestros necesarios </label>
            <md-input
              v-model="quantification.avegareMWorkers"
              type="number"
              min="0"
              :disabled="true"
            ></md-input>
          </md-field>
        </div>

        <div
          class="md-layout-item md-size-20 md-medium-size-33 md-small-size-50"
        >
          <md-field class="md-item md-size-25">
            <label> Oficiales necesarios </label>
            <md-input
              v-model="quantification.avegareOWorkers"
              type="number"
              min="0"
              :disabled="true"
            ></md-input>
          </md-field>
        </div>

        <div
          class="md-layout-item md-size-20 md-medium-size-33 md-small-size-50"
        >
          <md-field class="md-item md-size-25">
            <label> Ayudantes necesarios </label>
            <md-input
              v-model="quantification.avegareAWorkers"
              type="number"
              min="0"
              :disabled="true"
            ></md-input>
          </md-field>
        </div>

        <div
          class="md-layout-item md-size-20 md-medium-size-33 md-small-size-50"
        >
          <md-field class="md-item md-size-25">
            <label> Bandereros necesarios </label>
            <md-input
              v-model="quantification.avegareFWorkers"
              type="number"
              min="0"
              :disabled="true"
            ></md-input>
          </md-field>
        </div>
      </div>
    </md-card-header>
    <md-card-header class="md-layout md-secondary">
      <div class="md-layout-item md-size-100 md-title">
        <md-icon class="md-primary md-size-1x" style="margin: 0 10px 5px 10px">
          dashboard
        </md-icon>
        Conceptos
      </div>
    </md-card-header>
    <md-card-content>
      <md-table
        v-model="quantification.concepts"
        md-sort="id"
        md-sort-order="asc"
      >
        <md-table-row slot="md-table-row" slot-scope="{ item, index }">
          <md-table-cell md-label="Nombre">
            <md-chip class="md-caption md-warning">
              <strong>
                {{ item.code }}
              </strong>
            </md-chip>
            <div style="max-width: 350px">
              {{ item.name }}
            </div>
          </md-table-cell>
          <md-table-cell md-label="Cant.">
            {{ item.quantity }}
          </md-table-cell>
          <md-table-cell md-label="Cant. ejecutada">
            {{ item.realQuantity }}
          </md-table-cell>
          <md-table-cell md-label="Precio unitario">
            {{ getCurrency(item) }}</md-table-cell
          >
          <md-table-cell md-label="Unidad de medida">{{
            item.unitMeasurementName
          }}</md-table-cell>
          <md-table-cell md-label="Subtotal Insumos">
            {{ (item.suppliesSum * item.quantity) | money }}
          </md-table-cell>
          <md-table-cell md-label="Subtotal">
            {{ (item.unitPriceMXN * item.quantity) | money }}
          </md-table-cell>
          <md-table-cell md-label="No ejecutar">
            <md-checkbox v-model="item.notToDo" :disabled="true" />
          </md-table-cell>
          <md-table-cell md-label="No se repara">
            <md-checkbox v-model="item.cannotBeRepaired" :disabled="true" />
          </md-table-cell>
        </md-table-row>
      </md-table>
      <md-card-header>
        <div class="footer-table md-table">
          <table>
            <tfoot>
              <tr>
                <th />
                <th />
                <th />
                <th />
                <th />
                <th />
                <th />
                <th />
                <th class="align-right">
                  <md-icon class="tooltip-h">
                    help_outline
                    <md-tooltip md-direction="left">
                      Cantidad original calculada por el costo de los conceptos
                      para la reparación del siniestro.
                    </md-tooltip>
                  </md-icon>
                </th>
                <th>Total Reparado</th>
                <th>
                  {{ totalReal | money }}
                </th>
              </tr>
              <tr>
                <th />
                <th />
                <th />
                <th />
                <th />
                <th />
                <th />
                <th />
                <th class="align-right">
                  <md-icon class="tooltip-h">
                    help_outline
                    <md-tooltip md-direction="left">
                      Precio por la cantidad de materiales realmente usada para
                      la reparación.<br />
                      (cantidad reparada por precio de material)
                    </md-tooltip>
                  </md-icon>
                </th>
                <th>Total Insumos</th>
                <th>
                  {{ suppliesTotalReal | money }}
                </th>
              </tr>
              <tr>
                <th />
                <th />
                <th />
                <th />
                <th />
                <th />
                <th />
                <th />
                <th class="align-right">
                  <md-icon class="tooltip-h">
                    help_outline
                    <md-tooltip md-direction="left">
                      Porcentaje que se ocupa del total reparado con base al
                      total real.
                    </md-tooltip>
                  </md-icon>
                </th>
                <th>Costo Directo</th>
                <th>
                  {{ directCost | percentage }}
                </th>
              </tr>
            </tfoot>
          </table>
        </div>
      </md-card-header>
    </md-card-content>
  </md-card>
</template>

<script>
import percentage from "@/filters/percentage";

export default {
  name: "ConceptsList",
  props: {
    currencies: {
      type: Array,
      required: true,
      default: () => [],
    },
    casualty: {
      type: [Object, null],
      required: false,
      default: () => {},
    },
    roadSinister: {
      type: [Object, null],
      required: false,
      default: () => {},
    },
    quantification: {
      type: [Object, null],
      required: false,
      default: () => {},
    },
  },
  filters: {
    percentage,
  },
  computed: {
    total() {
      const concepts = this.quantification.concepts.filter(
        ({ notToDo, canNotBeRepaired }) => !(notToDo || canNotBeRepaired)
      );
      return concepts
        .map((c) => c.unitPriceMXN * c.quantity)
        .reduce((a, b) => a + b);
    },
    totalReal() {
      const concepts = this.quantification.concepts.filter(
        ({ notToDo, canNotBeRepaired }) => !(notToDo || canNotBeRepaired)
      );
      const priceField = "unitPriceMXN";
      if (!concepts.length) {
        return 0;
      }
      return concepts.reduce(
        (sum, c) => sum + c[priceField] * c.realQuantity,
        0
      );
    },
    suppliesTotal() {
      const concepts = this.quantification.concepts.filter(
        ({ notToDo, canNotBeRepaired }) => !(notToDo || canNotBeRepaired)
      );
      return concepts.reduce(
        (sum, concept) => concept.quantity * concept.suppliesSum + sum,
        0
      );
    },
    suppliesTotalReal() {
      const concepts = this.quantification.concepts.filter(
        ({ notToDo, canNotBeRepaired }) => !(notToDo || canNotBeRepaired)
      );
      if (!concepts.length) {
        return 0;
      }
      return concepts.reduce((sum, concept) => {
        return concept.realQuantity * concept.suppliesSum + sum;
      }, 0);
    },

    directCost() {
      let { suppliesTotalReal, totalReal } = this;
      if (totalReal == 0) {
        return 0;
      }
      suppliesTotalReal = suppliesTotalReal || 0;
      return (suppliesTotalReal * 100) / totalReal;
    },
  },
  methods: {
    getCurrency({ unitPriceEUR, unitPriceMXN, unitPriceUSD }) {
      if (+unitPriceEUR) {
        const found = this.currencies.find((c) => c.codename === "EUR");
        return `${found.symbol}${+unitPriceEUR}`;
      }
      if (+unitPriceMXN) {
        const found = this.currencies.find((c) => c.codename === "MXN");
        return `${found.symbol}${+unitPriceMXN}`;
      }
      if (+unitPriceUSD) {
        const found = this.currencies.find((c) => c.codename === "USD");
        return `${found.symbol}${+unitPriceUSD}`;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.md-tooltip {
  z-index: 110;
  word-wrap: break-word;
}
.form-scope {
  margin: 0 0 20px 0;
}
.md-card {
  padding: 7px;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/RoadSinisters/CloseProject/BudgetTable.vue